export default __webpack_public_path__ + "static/media/Macro2_assumed_plasticization.f0aa85d0.png";